/* ============================================================
   PRAXIS — product page progressive enhancement
   Opens a target <details> (e.g. the Reviews accordion) when an
   in-page anchor points to it — so the star-rating "Reviews" link
   both scrolls to AND opens the accordion. Pure enhancement; the
   page works without it. No cart/variant logic here.
   ============================================================ */
(function () {
  if (window.__praxisPdpInit) return;
  window.__praxisPdpInit = true;

  function openDetailsFor(selector) {
    if (!selector || selector.length < 2 || selector.charAt(0) !== '#') return;
    var el;
    try {
      el = document.querySelector(selector);
    } catch (e) {
      return;
    }
    if (!el) return;
    var details = el.tagName === 'DETAILS' ? el : el.closest('details');
    if (details && !details.open) details.open = true;
  }

  function openFromHash() {
    openDetailsFor(window.location.hash);
  }

  window.addEventListener('hashchange', openFromHash);
  if (document.readyState !== 'loading') openFromHash();
  else document.addEventListener('DOMContentLoaded', openFromHash);

  // Open immediately on click (before the hash scroll) for a smooth jump.
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#"]');
    if (a) openDetailsFor(a.getAttribute('href'));
  });
})();
